import * as React from "react";
import styled, { css } from "styled-components";

import { sentenceCase } from "src/library/utils/string-manipulations";
import { ThemeType } from "src/library/utils/theme";
import {
  Text,
  ITextProps
} from "src/library/components/Text/Text";
import { TransactionStatus } from "src/modules/payment/api/transactions.api";
import { transactionStatusToHuman } from "src/modules/payment/utils";

interface TransactionStatusProps extends ITextProps {
  status: TransactionStatus;
}

interface StyledTransactionStatusProps {
  status: TransactionStatus;
}

/**
 * The transaction status
 */
const TransactionStatusText = ({ status, ...rest }: TransactionStatusProps) => {
  return (
    <StyledTransactionStatus
      status={status}
      {...rest}
    >
      {sentenceCase(transactionStatusToHuman(status))}
    </StyledTransactionStatus>
  );
};

export default TransactionStatusText;

const StyledTransactionStatus = styled(Text)<StyledTransactionStatusProps>`
  ${({ status, theme }) => css`
    color: ${setStatusColor(status, theme)};
  `};
`;

/**
 * Sets the status colour depending on the status given
 */
const setStatusColor = (status: TransactionStatus, theme: ThemeType): string => {
  switch (status) {
    case TransactionStatus.REQUIRES_PAYMENT_METHOD:
    case TransactionStatus.REQUIRES_CONFIRMATION:
    case TransactionStatus.REQUIRES_ACTION:
    case TransactionStatus.FAILED:
      return theme.colors.error;

    case TransactionStatus.REQUIRES_CAPTURE:
    case TransactionStatus.PROCESSING:
    case TransactionStatus.CANCELED:

      return theme.colors.warn;

    case TransactionStatus.SUCCEEDED:
      return theme.colors.success;
  }
};
